import api from '../../../services/Api';
import { IAuditoriaSocietariaResultado } from '../interfaces/IAuditoriaSocietaria';

export const AuditoriaSocietariaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaSocietariaResultado> {
    const response = await api.get<IAuditoriaSocietariaResultado>('auditoria-societaria/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        totalErros: 0,
        totalAlertas: 0,
        totalAvisos: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoLegal: '',
        capitalSocial: [],
      }
    );
  },
};
